export enum TasksSearchFilterType {
  Launches = 'Launches',
  Deposits = 'Deposits',
  Conditions = 'Conditions',
  Settlements = 'Settlements',
  Terminations = 'Terminations',
  Overdue = 'Overdue',
}
